export default __webpack_public_path__ + "static/media/metaverse.hevc.8ab4b831.mp4";